import { Typography, RadioGroup, FormControlLabel, Radio } from "@material-ui/core";
import "../../styles/Globales.scss";
import "../../styles/SolicitarPortabilidad.scss";

import React, { Component } from "react";
import PropTypes from "prop-types";

const SI = "SI";
const NO = "NO";

export default class PreguntaPortarTodosComponent extends Component {
  constructor(props) { // eslint-disable-line
    super(props);
  }

  onSeleccionChange = (evt) => {
    const value = evt.target.value;
    if (this.props.onSeleccionChange) {
      this.props.onSeleccionChange(value);
    }
  };

  render() {
    let classSi = 'none';
    let classNo = 'none';
    if (this.props.portarTodos === SI) {
      classSi = "bordeDestacado";
    } else if (this.props.portarTodos === NO) {
      classNo = "bordeDestacado";
    }
    return (
      <div>
        <Typography className="tituloStepSolicitud">
          Puedes elegir portar todos los productos de <strong>{this.props.nombreBanco}</strong> a <strong>Banco Ripley</strong>, nosotros nos haremos cargo del resto.
        </Typography>
        <Typography className="preguntaPortar">¿Deseas portar todos tus productos?</Typography>
        <RadioGroup aria-label="gender" name="gender1" className="opcionesCompromiso Grande" value={this.props.portarTodos} onChange={this.onSeleccionChange}>
          <FormControlLabel control={<Radio color="primary" />} label="Si, portar todos" className={classSi} value={SI} />
          <FormControlLabel control={<Radio color="primary" />} label="No, sólo algunos" className={classNo} value={NO} />
        </RadioGroup>
      </div>
    );
  }
}

PreguntaPortarTodosComponent.propTypes = {
  onSeleccionChange: PropTypes.func.isRequired,
  portarTodos: PropTypes.string,
  nombreBanco: PropTypes.string,
}